// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hw_wicb0oH2LlakWb8kx {
  position: absolute;
  top: 30%;
}
.j8WumkZ6GRI9ogZBeXLT {
  left: 10%;
}
.Is6J0ZtAbnWHcUj59WLw {
  left: 75%;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/RightPanel/UnitPanel/components/StreamUnit/styles.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;AACF;AAEA;EACE,SAAA;AAAF;AAGA;EACE,SAAA;AADF","sourcesContent":[".streamName {\n  position: absolute;\n  top: 30%;\n}\n\n.streamIn {\n  left: 10%;\n}\n\n.streamOut {\n  left: 75%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"streamName": `hw_wicb0oH2LlakWb8kx`,
	"streamIn": `j8WumkZ6GRI9ogZBeXLT`,
	"streamOut": `Is6J0ZtAbnWHcUj59WLw`
};
export default ___CSS_LOADER_EXPORT___;
